import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"
}), 'LastPageSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LastPageSharp.js
// module id = 4423
// module chunks = 2